import { useEffect, useState } from "react";

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
    const [devicePixelRatio, setDevicePixelRatio] = useState<number | undefined>(undefined);
    const [isMobile, setIsMobile] = useState(false);

    const handleWindowSizeChange = () => {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight });

        setDevicePixelRatio(window.devicePixelRatio);

        if (window.innerWidth < 992) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        // oxlint-disable-next-line react/set-state-in-effect
        handleWindowSizeChange();

        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    return { windowSize, devicePixelRatio, isMobile };
};

export default useWindowSize;
